import { render, staticRenderFns } from "./soview.vue?vue&type=template&id=5acfc0c2&scoped=true&"
import script from "./soview.vue?vue&type=script&lang=js&"
export * from "./soview.vue?vue&type=script&lang=js&"
import style0 from "./soview.vue?vue&type=style&index=0&id=5acfc0c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfc0c2",
  null
  
)

export default component.exports